<script>
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	import { acceptedFileUploadList } from "../../config";
	import { pageNumber, model } from "../../stores";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let nextPageLabel = null;

	let id = "fileUploader";
	let options = {
		url: "/api/file-upload?token=" + $model.RegistrationToken,
		acceptedFiles: acceptedFileUploadList
	};

	$model.documentList = $model.documentList || [];

	pageNumber.update((p) => pageIndex);
	document.title = pageTitle;

	let documentUploadError = "";

	const validateDocuments = () => {
		let isValid = $model.documentList.length > 0;
		documentUploadError = isValid ? "" : "Please upload documents";
		return isValid;
	};

	const getDocumentUploadError = () => {
		let isValid = validateDocuments();
		return isValid ? [] : [document.getElementById("docUploadError")];
	};
</script>

<PageSection>
	<div class="form-row">
		<!-- <div class="form-row" transition:slide> -->
		<div class="form-group col-md-12">
			<h1>Supporting Documentation</h1>
			<p>
				If you experience any issues with uploading your supporting documentation please email our team at <ClassActionEmailAddress
				></ClassActionEmailAddress> and continue to complete your registration.
			</p>
			<DropZone
				{options}
				{id}
				message="Drop files here or click to upload"
				bind:documentList={$model.documentList}
			></DropZone>
		</div>
	</div>

	<div class="form-row">
		<div class="col-md-12 last">
			<NavigationButtons
				onValidate={getDocumentUploadError}
				{persistUrl}
				{previousPage}
				{nextPage}
				{nextPageLabel}
			></NavigationButtons>
		</div>
		{#if documentUploadError}
			<div id="docUploadError" class="error-message">
				{documentUploadError}
			</div>
		{/if}
	</div>
</PageSection>
